import { Button, Checkbox, Input, message, Modal } from 'antd';
import React, { useState } from 'react';
import { Form } from 'antd';
import Instance from '../AxiosConfig';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const DeleteAccount = () => {
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState('');
    const [reason, setReason] = useState("");
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false); // ✅ For Modal
    const navigate =  useNavigate();

    const handleOk = async (e) => {
        e.preventDefault();
        console.log("Clicked");
        if (!email || !password || !reason || !isConfirmed) {
            message.warning("Please fill required fields and confirm deletion.");
            return;
        }

        const requestDto = {
            email,
            password,
            reason,
            confirmed: isConfirmed,
        };

        try {
            setLoading(true);
            const response = await Instance.post("/api/v1/user/delete-account", requestDto);
            console.log("response", response.data);
            // message.success("Your account deletion request has been received and will be processed within 24 hours.");
            setIsDeleted(true);
            setModalVisible(true); // ✅ Show Modal
            setEmail('');
            setPassword('');
            setReason('');
            setIsConfirmed(false);
        } catch (error) {
            const errorMsg =
                error?.response?.data?.message || "Failed to delete account. Please try again later.";
            message.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    const handleShop = () => {
        setModalVisible(false);
        navigate("/shop")
    };

    return (
        <>
            <div className="container-fluid" style={{ overflow: "hidden" }}>
                <div className="row shop-banner-row">
                    <div className="col-md-6 justify-content-center banner-content-contact px-5">
                        <h5 className="banner-header-returns" style={{ fontWeight: "700", fontStyle: "italic", fontSize: "48px", color: "#fff" }}>
                            Account Deletion
                        </h5>
                        <p style={{ fontSize: "22px", color: "#fff" }}>
                            We're sorry to see you go. Deleting your account is permanent and cannot be recovered. Please review the information carefully before proceeding.
                        </p>
                        <button className="explore-button-shop">Contact Us</button>
                    </div>
                </div>
            </div>

            <div className="row contact-main">
                <div className='col-lg-3'></div>
                <div className='col-lg-6 container mb-3'
                    style={{
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "24px",
                    }}>
                    <Form layout="vertical">
                        <Form.Item label="Email" required>
                            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </Form.Item>

                        <Form.Item label="Password" required>
                            <Input.Password value={password} onChange={(e) => setPassword(e.target.value)} />
                        </Form.Item>

                        <Form.Item label="Reason for leaving" required>
                            <Input.TextArea value={reason} onChange={(e) => setReason(e.target.value)} />
                        </Form.Item>

                        <Form.Item>
                            <Checkbox checked={isConfirmed} onChange={(e) => setIsConfirmed(e.target.checked)}>
                                I understand that deleting my account is permanent and cannot be recovered.
                            </Checkbox>
                        </Form.Item>

                        <div style={{ textAlign: "right" }}>
                            <Button
                                type="primary"
                                danger
                                onClick={handleOk}
                                loading={loading}
                                disabled={!isConfirmed || !email || !password || !reason}
                            >
                                Delete Account
                            </Button>
                        </div>
                    </Form>
                </div>
                <div className='col-lg-3'></div>
            </div>

            {/* ✅ Modal */}
            <Modal
                visible={modalVisible}
                footer={null}
                onCancel={() => {setModalVisible(false)
                    navigate("/")
                }}
                centered
            >
                <div className="d-flex justify-content-center flex-column forgot-password-div" style={{ textAlign: "center" }}>
                    <div className='d-flex justify-content-center'>
                        <CheckCircleOutlined
                        style={{ color: "green", fontSize: "70px", marginBottom: "20px" }}
                    />
                    </div>
                    <h3>Request submitted successfully</h3>
                    <h6 style={{ color: "#54595e", marginTop:"10px" }}>Your request is under review and will be processed within 24 hours.</h6>
                    {/* <div className="d-flex gap-4 justify-content-center mt-3">
                        <Button
                            type="primary"
                            className="continue-button"
                            onClick={handleShop}
                        >
                            Continue Shopping
                        </Button>
                    </div> */}
                </div>
            </Modal>
        </>
    );
};

export default DeleteAccount;
